var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mappables-container"},_vm._l((_vm.mappables),function(mappable){return _c('div',{key:mappable.id},[_c('mappable-list-item',{attrs:{"mappable":mappable,"onClick":_vm.onClick}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }